export const experienceData = [
    {
        id: 1,
        company: 'Arwin Networks',
        jobtitle: 'Frontend Developer',
        startYear: '06/2023',
        endYear: '10/2023'
    },
    {
        id: 2,
        company: 'LiveWire',
        jobtitle: 'Web Developer',
        startYear: '07/2023',
        endYear: '12/2023'
    },
    {
        id: 3,
        company: 'Placement 360',
        jobtitle: 'Campus Ambassador',
        startYear: '07/2023',
        endYear: '12/2023'
    },
]